import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  &::after,
  &::before {
    content: '';
    position: absolute;
    max-width: 100%;
    width: 450px;
    height: 580px;
    background-size: contain;
    background-repeat: no-repeat;
    top: 0;
  }

  &::before {
    background-image: url('https://cdn.brain.fm/images/marketing_circles_blur_left.webp');
    left: -20px;
  }

  &::after {
    background-image: url('https://cdn.brain.fm/images/marketing_circles_blur_right.webp');
    right: 0;
  }
`;
